import type { ProductType } from '@atlaskit/linking-common';

export const helpCenterTypeToProduct = (helpCenterType: string): ProductType => {
	switch (helpCenterType) {
		case 'CUSTOMER_SERVICE':
			return 'CSM';
		case 'HELP_HUB':
			return 'JSM';
		default:
			return 'CSM';
	}
};
